<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?'签约供应商':'修改签约的供应商'}}</myNav>
            <div class="flex-box bg-f8">
                <div class="flex-box-bd tleft">供应商：{{vendor_info.vendor_cname}}</div>
            </div>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-form-item :label="vendor_info.mac_id_nick" prop="mac_id">
                <el-input v-model="formData.mac_id" :placeholder="$t('input')"></el-input>
            </el-form-item>
            <el-form-item :label="vendor_info.api_key_nick" prop="api_key">
                <el-input v-model="formData.api_key" :placeholder="$t('input')"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                op: this.$base.getRequest().op,
                formData: {
                    vendor_id:'',//新增时需要
                    org_vendor_id:'',
                    mac_id: '',
                    api_key: ''
                },
                rule: {
                    mac_id: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    api_key: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                },

                vendor_info: {},
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var para = this.$base.getRequest();
            if(this.op == 'upd'){
                this.formData.org_vendor_id = para.org_vendor_id;
                this.getInfo();
            }
            else{
                this.formData.vendor_id = para.vendor_id;
                this.getLoad();
            }
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                var data = {
                    vendor_id: this.formData.vendor_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-vendor/before-add",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.vendor_info = data.vendor_info
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getInfo: function(){
                var data = {
                    org_vendor_id: this.formData.org_vendor_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-vendor/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.vendor_info = data.vendor_info
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = this.op=='upd'?"org-vendor/upd":"org-vendor/add";
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/base/orgvendor/save.vue